// Generated by ReScript, PLEASE EDIT WITH CARE

import Moment from "moment";
import * as ReactDates from "../../externals/ReactDates.res.js";
import * as ReactDates$1 from "react-dates";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Nullable from "@rescript/runtime/lib/es6/Stdlib_Nullable.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";

let defaultFocusedInput = ReactDates.DayPickerRangeController.defaultFocusedInput;

function DayPickerRange(props) {
  let onChange = props.onChange;
  return JsxRuntime.jsx(ReactDates$1.DayPickerRangeController, {
    startDate: Stdlib_Nullable.fromOption(Stdlib_Option.map(props.startDate, prim => Moment(prim))),
    endDate: Stdlib_Nullable.fromOption(Stdlib_Option.map(props.endDate, prim => Moment(prim))),
    onDatesChange: param => onChange([
      Stdlib_Option.map(Primitive_option.fromNullable(param.startDate), prim => prim.toDate()),
      Stdlib_Option.map(Primitive_option.fromNullable(param.endDate), prim => prim.toDate())
    ]),
    onPrevMonthClick: Stdlib_Option.map(props.onPrevMonthClick, fn => (moment => fn(moment.toDate()))),
    onNextMonthClick: Stdlib_Option.map(props.onNextMonthClick, fn => (moment => fn(moment.toDate()))),
    onFocusChange: props.onFocusChange,
    transitionDuration: 0,
    noBorder: true,
    focusedInput: props.focusedInput,
    initialVisibleMonth: Stdlib_Option.map(props.initialVisibleMonth, fn => (() => Moment(fn()))),
    maxDate: Stdlib_Option.map(props.maxDate, maxDate => Moment(maxDate)),
    isOutsideRange: Stdlib_Option.map(props.isOutsideRange, fn => (moment => fn(moment.toDate()))),
    minimumNights: 0
  });
}

let make = DayPickerRange;

export {
  defaultFocusedInput,
  make,
}
/* moment Not a pure module */
